export default {
  beforeMount(el: HTMLElement) {
    el.classList.add('print:hidden')
  }
}
